import React from 'react';
import fncLogoColor from '@/assets/fnc-logo.png';

interface FNCLogoProps {
  variant?: 'light' | 'dark';
  className?: string;
}

// FNC Official Logo - Using official brand image
export const FNCLogo: React.FC<FNCLogoProps> = ({ variant = 'light', className = '' }) => {
  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src={fncLogoColor} 
        alt="Federación Nacional de Cafeteros de Colombia" 
        className={`h-24 md:h-32 w-auto object-contain ${variant === 'light' ? 'brightness-0 invert' : ''}`}
      />
    </div>
  );
};

export default FNCLogo;
